import React from 'react';

function StaticField({ label, value = '' }) {
  return (
    <div className="staticField">
      <div className="label">
        {label}
        <div className="value">{value || 'N/A'}</div>
      </div>
    </div>
  );
}

export default StaticField;
